import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { AppRoutes } from '@/constants/routes';

/**
 * Period Closing Form — create or view a period closing entry.
 * The actual close/reopen actions are available directly on the list page.
 */
export const PeriodClosingFormPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const isNew = !id;

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <button
        onClick={() => navigate(AppRoutes.PERIOD_CLOSING_LIST)}
        className="flex items-center gap-1 text-sm text-gray-500 dark:text-gray-400 hover:text-gray-800 mb-4"
      >
        <ArrowLeft className="h-4 w-4" /> Back to Period Closing
      </button>
      <h1 className="text-xl font-semibold mb-6">
        {isNew ? 'New Period Close Request' : 'Period Close Details'}
      </h1>
      <p className="text-gray-500 dark:text-gray-400">
        Use the Period Closing list to initiate close and reopen actions for each module and period.
        Select a period from the list to view details or take action.
      </p>
    </div>
  );
};
